import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { RootComponent } from './app/app.root';

bootstrapApplication(RootComponent, appConfig)
  .catch((err) => console.info(err));